import { Types } from "./descriptors";
import { BuilderEditMode } from "../state/modules/builder-edit-mode";
import {
  ListControl,
  ListControlType,
  RichTextControl,
  RichTextControlType,
  ShapeControl,
  ShapeControlType,
  richTextDAOToDTO,
  SlotControl,
  SlotControlType,
  StyleControl,
  StyleControlType,
  RichTextV2ControlType,
  RichTextV2Control,
  StyleV2Control,
  StyleV2ControlType
} from "../controls";
import { PropController } from "./base";
const RichTextPropControllerMessageType = {
  CHANGE_BUILDER_EDIT_MODE: "CHANGE_BUILDER_EDIT_MODE",
  INITIALIZE_EDITOR: "INITIALIZE_EDITOR",
  CHANGE_EDITOR_VALUE: "CHANGE_EDITOR_VALUE",
  FOCUS: "FOCUS",
  BLUR: "BLUR",
  UNDO: "UNDO",
  REDO: "REDO",
  CHANGE_BOX_MODEL: "CHANGE_BOX_MODEL"
};
class DefaultPropController extends PropController {
  recv = (_message) => {
  };
}
class RichTextPropController extends PropController {
  editor = null;
  recv = (message) => {
    if (!this.editor)
      return;
    switch (message.type) {
      case RichTextPropControllerMessageType.CHANGE_BUILDER_EDIT_MODE: {
        switch (message.editMode) {
          case BuilderEditMode.BUILD:
          case BuilderEditMode.INTERACT:
            this.editor.deselectAndBlur();
        }
        break;
      }
      case RichTextPropControllerMessageType.FOCUS: {
        this.editor.focusAndSelectAll();
        break;
      }
    }
  };
  setSlateEditor(editor) {
    this.editor = editor;
    this.send({
      type: RichTextPropControllerMessageType.INITIALIZE_EDITOR,
      value: richTextDAOToDTO(editor.children, editor.selection)
    });
    const _onChange = editor.onChange;
    this.editor.onChange = (options) => {
      _onChange(options);
      if (options?.operation != null) {
        this.send({
          type: RichTextPropControllerMessageType.CHANGE_EDITOR_VALUE,
          value: richTextDAOToDTO(editor.children, editor.selection)
        });
      }
    };
  }
  focus() {
    this.send({ type: RichTextPropControllerMessageType.FOCUS });
  }
  blur() {
    this.send({ type: RichTextPropControllerMessageType.BLUR });
  }
  undo() {
    this.send({ type: RichTextPropControllerMessageType.UNDO });
  }
  redo() {
    this.send({ type: RichTextPropControllerMessageType.REDO });
  }
  changeBoxModel(boxModel) {
    this.send({ type: RichTextPropControllerMessageType.CHANGE_BOX_MODEL, payload: { boxModel } });
  }
}
const TableFormFieldsMessageType = {
  TABLE_FORM_LAYOUT_CHANGE: "TABLE_FORM_LAYOUT_CHANGE",
  TABLE_FORM_FIELD_LAYOUT_CHANGE: "TABLE_FORM_FIELD_LAYOUT_CHANGE"
};
class TableFormFieldsPropController extends PropController {
  recv = () => {
  };
  tableFormLayoutChange(payload) {
    this.send({ type: TableFormFieldsMessageType.TABLE_FORM_LAYOUT_CHANGE, payload });
  }
  tableFormFieldLayoutChange(payload) {
    this.send({ type: TableFormFieldsMessageType.TABLE_FORM_FIELD_LAYOUT_CHANGE, payload });
  }
}
function createPropController(descriptor, send) {
  switch (descriptor.type) {
    case Types.RichText:
      return new RichTextPropController(send);
    case Types.TableFormFields:
      return new TableFormFieldsPropController(send);
    case SlotControlType:
      return new SlotControl(send);
    case RichTextControlType:
      return new RichTextControl(send);
    case RichTextV2ControlType:
      return new RichTextV2Control(send, descriptor);
    case ListControlType:
      return new ListControl(send, descriptor);
    case ShapeControlType:
      return new ShapeControl(send, descriptor);
    case StyleControlType:
      return new StyleControl(send);
    case StyleV2ControlType:
      return new StyleV2Control(send, descriptor);
    default:
      return new DefaultPropController(send);
  }
}
export {
  RichTextPropControllerMessageType,
  TableFormFieldsMessageType,
  TableFormFieldsPropController,
  createPropController
};
//# sourceMappingURL=instances.js.map